import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { SoonPage, IndexPage, NotFoundPage, FundPage } from './pages';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './store/store';

const Index = () => {
  return (
    <Router basename={process.env.PUBLIC_URL} hashType="slash">
      <Routes>
        <Route exact path="/" element={<IndexPage />} />
        <Route exact path="/home" element={<FundPage/>} />
        <Route exact path="/labs" element={<SoonPage/>} />
        <Route exact path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" />} />   
      </Routes>
    </Router>
  )
};

  
ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <Index />
    </React.StrictMode>  
  </Provider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
